/**************************************************************
* Responsive video loader with Intersection Observer
* - Loads video when approaching viewport (50% margin)
* - Auto-plays when in viewport
* - Pauses when out of viewport
**************************************************************/

function fnResponsiveVideoLoading(i, oVideo) {
	var $video = $(oVideo),
		videoEl = $video[0];

	if (!videoEl || $video.data('observer-initialized')) return;

	$video.data('observer-initialized', true);

	var sSD = $video.attr('data-src'),
		sHD = $video.attr('data-hd-src'),
		sULTRAHD = $video.attr('data-ultrahd-src'),
		sScreenSize = $(window).width(),
		sVideoUrl = '';

	if (sScreenSize >= 1900) {
		sVideoUrl = sULTRAHD;
	} else if (sScreenSize >= 1350) {
		sVideoUrl = sHD;
	} else {
		sVideoUrl = sSD;
	}

	if (!sVideoUrl) return;

	var isLoaded = false;

	function loadVideo() {
		if (isLoaded) return;
		isLoaded = true;
		$video.append("<source src='" + sVideoUrl + "' type='video/mp4'>");
		videoEl.load();
	}

	function playVideo() {
		if (!isLoaded) return;
		
		var playPromise = videoEl.play();
		if (playPromise !== undefined) {
			playPromise.catch(function() {
				// Auto-play was prevented, ignore silently
			});
		}
	}

	function pauseVideo() {
		if (!videoEl.paused) {
			videoEl.pause();
		}
	}

	// Observer for loading (50% margin - starts loading half screen before)
	var loadObserver = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting && !isLoaded) {
				loadVideo();
				loadObserver.unobserve(videoEl);
			}
		});
	}, {
		rootMargin: '50% 0px',
		threshold: 0
	});

	// Observer for play/pause (when actually in viewport)
	var playObserver = new IntersectionObserver(function(entries) {
		entries.forEach(function(entry) {
			if (entry.isIntersecting) {
				if (!isLoaded) {
					loadVideo();
					videoEl.addEventListener('canplay', function onCanPlay() {
						videoEl.removeEventListener('canplay', onCanPlay);
						playVideo();
					}, { once: true });
				} else {
					playVideo();
				}
			} else {
				pauseVideo();
			}
		});
	}, {
		rootMargin: '0px',
		threshold: 0.1
	});

	loadObserver.observe(videoEl);
	playObserver.observe(videoEl);
}


// END OF DOCUMENT
